module.exports = __webpack_public_path__ + "static/img/2-3-6.a9e90a1a.png";